import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  headline() {
    return faker.name.fullName();
  },

  startDate() {
    return faker.date.past();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(calendarEvent, server) {
    let numArtists = faker.datatype.number({
      min: 1,
      max: 3,
    });

    calendarEvent.update({
      artists: server.createList('artist', numArtists),
      calendarTypeId: server.create('category', 'calendarEventType'),
    });
  },
});
